import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { UtilidadesService } from 'src/app/servicios/utilidades.service';

@Component({
  selector: 'app-popover-mostrar-link',
  templateUrl: './popover-mostrar-link.component.html',
  styleUrls: ['./popover-mostrar-link.component.scss'],
})
export class PopoverMostrarLinkComponent implements OnInit {
  @Input() Link = ""
  constructor(private utilidades: UtilidadesService, private popover: PopoverController) { }

  ngOnInit() {
    setTimeout(() => {
      this.Copiar()
    }, 200);
  }

  Copiar() {
    setTimeout(() => {
      this.utilidades.Toast("Copiado al portapapeles")
    }, 800);
    setTimeout(() => {
      var copyText = document.querySelector("#text");
    copyText["select"]();
    document.execCommand ("copy");
    }, 250);
    
  }

  Cerrar(){
    this.popover.dismiss()
  }
}
